<div oui-dialog-title>Supprimer la relation</div>

<oui-dialog-content>
  <div class="dialog-content">
    <p>
      Cette suppression est définitive. Confirmez la suppression de la relation
      <strong>{{ data.relationTypeLabel }}</strong>.
    </p>

    <dl>
      <div>
        <dt>Personne source</dt>
        <dd>{{ data.personLabel }} (#{{ data.personId }})</dd>
      </div>
      <div>
        <dt>Personne / investisseur lié</dt>
        <dd>{{ data.relatedEntityLabel }}</dd>
      </div>
    </dl>

    @if (error()) {
      <p class="error-text">{{ error() }}</p>
    }
  </div>
</oui-dialog-content>

<oui-dialog-actions>
  <oui-button
    type="outlined"
    color="secondary"
    [disabled]="executing()"
    (click)="close()">
    Annuler
  </oui-button>
  <oui-button
    iconSuffix="delete"
    [disabled]="!canDelete()"
    (click)="deleteRelation()">
    {{ executing() ? 'Suppression...' : 'Supprimer' }}
  </oui-button>
</oui-dialog-actions>
